/** Exporta los leads no gestionados a CSV (separador ';' para Excel en es-*). */
export function leadsToCsv(leads) {
  const cols = [
    ['Pipeline', (l) => l.pipelineName],
    ['Etapa', (l) => l.stageName],
    ['Tipo', (l) => l.kind],
    ['Nombre', (l) => l.name],
    ['Email', (l) => l.email || ''],
    ['Telefono', (l) => l.phone || ''],
    ['Valor', (l) => l.value || 0],
    ['Severidad', (l) => l.severity],
    ['Dias sin avanzar', (l) => l.daysStuck ?? ''],
    ['Dias inactivo', (l) => l.daysInactive ?? ''],
    ['Responsable', (l) => l.assignedTo || 'sin asignar'],
    ['Origen', (l) => l.source || ''],
    ['Creado', (l) => l.createdAt || ''],
    ['Actualizado', (l) => l.updatedAt || ''],
    ['Motivos', (l) => l.reasons.map((r) => r.label).join(' | ')],
    ['Detalle', (l) => l.reasons.map((r) => r.detail).join(' | ')],
  ]
  const esc = (v) => {
    const s = String(v ?? '')
    return /[";\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s
  }
  const lines = [cols.map((c) => esc(c[0])).join(';')]
  for (const l of leads) lines.push(cols.map((c) => esc(c[1](l))).join(';'))
  return '﻿' + lines.join('\r\n')
}

export function descargarCsv(nombre, contenido) {
  const blob = new Blob([contenido], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = nombre
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
